/* global axios */
import ApiClient from '../ApiClient';

class MetaTemplates extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  get(inboxId, params = {}) {
    return axios.get(`${this.url}/${inboxId}/meta_message_templates`, {
      params,
    });
  }

  create(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/meta_message_templates`, {
      template,
    });
  }

  update(inboxId, templateId, template) {
    return axios.patch(
      `${this.url}/${inboxId}/meta_message_templates/${templateId}`,
      {
        template,
      }
    );
  }

  syncStatus(inboxId, templateId) {
    return axios.post(
      `${this.url}/${inboxId}/meta_message_templates/${templateId}/sync_status`
    );
  }
}

export default new MetaTemplates();
